// Apply a numeric text-input change to a scenario's params. Clearing the field (or any non-numeric
// input) makes parseFloat return NaN; drop the key so `params[key] ?? default` falls back to the
// scenario default instead of storing NaN — which reads as an uncontrolled input and serialises to
// `null` on run, overriding the default (#197).
export function applyParamChange(
  params: Record<string, number>,
  key: string,
  raw: string,
): Record<string, number> {
  const parsed = parseFloat(raw);
  const next = { ...params };
  if (Number.isNaN(parsed)) {
    delete next[key];
  } else {
    next[key] = parsed;
  }
  return next;
}
